module.exports = __webpack_public_path__ + "img/sq_get.40ce70f.png";